var collapsible_list_component_default = {
  "ltr": "H8dlV",
  "rtl": "fEv3j",
  "iconContainer": "_8xoXe",
  "icon": "_7BPqa",
  "isExpanded": "_1e78a",
  "listDimensions": "_7xior"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
